import React from 'react';
import { Modal, Button, Typography, Input, Space, Card, Row, Col, Select, Tag } from 'antd';
import { TeamOutlined, UserOutlined, CrownOutlined } from '@ant-design/icons';
import { NodeCharacterNPCPlan } from '../../api/models/Lifetree';

const { Text } = Typography;
const { TextArea } = Input;
const { Option } = Select;

interface CharacterPlanModalProps {
  open: boolean;
  onCancel: () => void;
  characters: NodeCharacterNPCPlan[];
  onCharacterChange: (index: number, updatedChar: NodeCharacterNPCPlan) => void;
  loading: boolean;
  onConfirm: () => void;
}

const CharacterPlanModal: React.FC<CharacterPlanModalProps> = ({
  open,
  onCancel,
  characters,
  onCharacterChange,
  loading,
  onConfirm,
}) => {
  return (
    <Modal
      title={
        <Space>
          <TeamOutlined style={{ color: '#1890ff' }} />
          <span>Kế hoạch Nhân vật và Định hướng (AI)</span>
        </Space>
      }
      open={open}
      onCancel={onCancel}
      width={900}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Hủy
        </Button>,
        <Button 
          key="confirm" 
          type="primary" 
          loading={loading}
          onClick={onConfirm}
        >
          Xác nhận
        </Button>
      ]}
    >
      <div style={{ marginBottom: 16 }}>
        <Text type="secondary">
          Dưới đây là danh sách nhân vật AI đề xuất cho Node này. Bạn có thể chỉnh sửa thông tin trực tiếp trước khi phê duyệt.
        </Text>
      </div>

      <div style={{ maxHeight: '65vh', overflowY: 'auto', paddingRight: 8 }}>
        <Row gutter={[16, 16]}>
          {characters.map((char, index) => (
            <Col span={24} key={index}>
              <Card 
                size="small" 
                title={
                  <Space>
                    {char.isMain ? <CrownOutlined style={{ color: '#faad14' }} /> : <UserOutlined />}
                    <Text strong>{char.isMain ? 'Nhân vật chính (Main)' : `NPC: ${char.name}`}</Text>
                    {char.isNew && <Tag color="green">Mới</Tag>}
                    {!char.isNew && <Tag color="blue">Cũ</Tag>}
                  </Space>
                }
                style={{ 
                  border: char.isMain ? '1px solid #ffd591' : undefined, 
                  background: char.isMain ? '#fffbe6' : undefined 
                }}
              >
                <Row gutter={16}>
                  <Col span={8}>
                    <div style={{ marginBottom: 8 }}>
                      <Text type="secondary" style={{ fontSize: 12 }}>Tên nhân vật:</Text>
                      <Input 
                        value={char.name} 
                        onChange={(e) => onCharacterChange(index, { ...char, name: e.target.value })} 
                        disabled={char.isMain} // Main name is fixed to {{userName}}
                      />
                    </div>
                    <div>
                      <Text type="secondary" style={{ fontSize: 12 }}>Giới tính:</Text>
                      <Select 
                        style={{ width: '100%' }}
                        value={char.gender}
                        onChange={(value) => onCharacterChange(index, { ...char, gender: value })}
                      >
                        <Option value="male">Nam (Male)</Option>
                        <Option value="female">Nữ (Female)</Option>
                        <Option value="other">Khác (Other)</Option>
                      </Select>
                    </div>
                  </Col>
                  <Col span={16}>
                    <Text type="secondary" style={{ fontSize: 12 }}>Mô tả trạng thái/thay đổi:</Text>
                    <TextArea 
                      rows={4} 
                      value={char.stateDescription} 
                      onChange={(e) => onCharacterChange(index, { ...char, stateDescription: e.target.value })}
                      placeholder="Nêu bật sự thay đổi so với state trước đó..."
                    />
                  </Col>
                </Row>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </Modal>
  );
};

export default CharacterPlanModal;
